var styles = {"scrollableWrapper":"Scrollable-module_scrollableWrapper__wdjZC","scrollableHeader":"Scrollable-module_scrollableHeader__jul7i","scrollableContainer":"Scrollable-module_scrollableContainer__H3pJ-"};

export { styles as default };
//# sourceMappingURL=Scrollable.module.scss.js.map
